import type { ProductGroup } from './product';

export interface Language {
    code: string;
    name: string;
    native_name: string;
}

export interface CurrentLanguage extends Language {
    id?: number;
}

export interface Region {
    code: string;
    name: string;
}

export interface Country {
    code: string;
    name: string;
}

export interface Currency {
    code: string;
    symbol: string;
}

export interface Contact {
    type: string;
    value: string;
}

export interface Category {
    id: number;
    slug_key: string;
    name: string;
}

export enum PromoBannerType {
    CAROUSEL = 'carousel',
    HEADER = 'header',
    FOOTER = 'footer',
    SUB_HEADER = 'sub-header',
    ORDER_SUCCESS = 'order_succesfully_created',
}

export interface PromoBanner {
    type: PromoBannerType;
    html: string;
}

export interface DomainContext {
    host: string;
    status: string;
    region: Region;
    country: Country;
    currency: Currency;
    current_language: CurrentLanguage;
    available_languages: Language[];
    contacts: Contact[];
    promo_banners: PromoBanner[];
    categories: Category[];
    products: ProductGroup[];
}

export interface SetLanguageResponse {
    current_language: CurrentLanguage;
    available_languages: Language[];
}
